/**
 * Form validation
 */
import $ from 'jquery';

$(function () {
    "use strict";

    /* Validate form without browser defaults */
    if ($('.needs-validation').length > 0) {
        $('.needs-validation').on('submit', function (e) {
            let form = $(this);
            if (form[0].checkValidity() === false) {
                e.preventDefault();
                e.stopPropagation();
            }
            form.addClass('was-validated');
        });
    }

    /* Validate phone number e.g. +49 / 0049 */
    if ($('.form-phone').length > 0) {
        $('.form-phone').on('keydown', function (e) {
            if (['Backspace', 'Tab', 'Home', 'End', 'ArrowLeft', 'ArrowRight', 'Delete', '+', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'].includes(e.key) === false) {
                e.preventDefault();
                return false;
            }

            let text = $(this).val();
            if (e.key === '+' && (text.indexOf("+") >= 0 || text.length > 0)) {
                return false;
            }
        });
        $('.form-phone').on('blur', function (e) {
            blurValidation($(this), true);
        });
    }

    /* Validate email input */
    if ($('.form-email').length > 0) {
        $('.form-email').on('blur', function (e) {
            let pattern = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/;
            blurValidation($(this), true, pattern);
        });
    }

    /* Validate digits only */
    if ($('.form-digits').length > 0) {
        $('.form-digits').on('keydown', function (e) {
            // Allow keys
            let keys = ['Backspace', 'Tab', 'Home', 'End', 'ArrowLeft', 'ArrowRight', 'Delete', '-', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
            // Add allowed seperators and decimals
            let seperator = $(this).data('seperator');
            let decimals = $(this).data('decimals');
            if (seperator !== undefined && seperator.length === 1 && decimals !== undefined && parseInt(decimals) > 0) {
                keys.push(seperator);
                let text = $(this).val();
                // Only one seperator
                if (e.key === seperator && (text.indexOf(seperator) >= 0 || text.length === 0)) {
                    e.preventDefault();
                    return false;
                }
            }
            // Prevent all other keys
            if (keys.includes(e.key) === false) {
                e.preventDefault();
                return false;
            }
        });

        $('.form-digits').on('blur', function (e) {
            // Handle min and max
            let valid = true;
            let min = $(this).data('min');
            if (min !== undefined && parseFloat($(this).val()) < parseFloat(min)) {
                valid = false;
            }
            // Handle max
            let max = $(this).data('max');
            if (max !== undefined && parseFloat($(this).val()) > parseFloat(max)) {
                valid = false;
            }

            blurValidation($(this), valid);
        });
    }

    /* Clean house / street autofill */
    if ($('.house-autofill').length > 0 && $('.street-autofill').length > 0) {
        $('.street-autofill, .house-autofill').on('change, blur', function() {
            let house = $('.house-autofill').val();
            let street = $('.street-autofill').val().trim();

            if (street != '') {
                street = street.replace(house, '');
                $('.street-autofill').val(street.trim());
            }
        });
    }

    /* Show and hide password */
    if($('.show-hide-password').length > 0) {
        $(document).on('click', '.show-hide-password', function(e){
            var type = $(this).parents('.input-group:first').find('input').attr('type');
            if(type == 'text') {
                $(this).parents('.input-group:first').find('input').attr('type', 'password');
                $(this).find('.fas').removeClass('fa-eye');
                $(this).find('.fas').addClass('fa-eye-slash');
            } else {
                $(this).parents('.input-group:first').find('input').attr('type', 'text');
                $(this).find('.fas').removeClass('fa-eye-slash');
                $(this).find('.fas').addClass('fa-eye');
            }
        });
    }

    /* No paste allowed */
    if ($('.form-nopaste').length > 0) {
        $(document).on('paste', '.form-nopaste', function(e) {
            e.preventDefault();
        });
    }

    /* Validate input on blur */
    function blurValidation(input, valid, regex) {
        let text = input.val();
        let pattern = (typeof regex === 'undefined') ? input.attr('pattern') : regex;
        let parent = input.closest('.input-group');
        if (typeof pattern !== 'undefined' && text.length > 0) {
            if (new RegExp(pattern).test(text) && valid === true) {
                input.removeClass('is-invalid');
                if (parent.length > 0) {
                    parent.removeClass('has-validation');
                }
            } else {
                input.addClass('is-invalid');
                if (parent.length > 0) {
                    parent.addClass('has-validation');
                }
            }
        }
    }
});
